import React from 'react';
import AnalyticsManager from './components/AnalyticsManager';

const AnalyticsView = () => {
    return <AnalyticsManager />;
};

export default AnalyticsView; 